import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { collection, getDocs, addDoc } from "firebase/firestore";
import db from "../firestore";
import { ToastContainer, toast } from "react-toastify";

function Certificate() {
  const [certificates, setCertificates] = useState([]);
  const [name, setName] = useState([]);
  const [field, setField] = useState([]);
  const [date, setDate] = useState([]);
  const [imageLink, setImageLink] = useState("");

  const CertificateRef = collection(db, "Certificates");

  useEffect(() => {
    const getCertificates = async () => {
      const data = await getDocs(CertificateRef);
      setCertificates(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getCertificates();
  }, []);

  const createCertificate = async () => {
    await addDoc(CertificateRef, {
      Name: name,
      Field: field,
      Date: date,
      ImageLink: imageLink,
    }).then(
      toast.success("Added 👍", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    );
  };

  return (
    <div>
      <Header />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="w-screen flex flex-col items-center">
        <div className="w-3/4 border rounded-md mt-10">
          <h1 className="text-3xl font-bold p-5">Certificates</h1>
          <div className="m-5 p-5 border flex flex-col items-center gap-5">
            <h2 className="text-xl w-full">Add New Certificate</h2>
            <input
              type="text"
              placeholder="Certificate Holder Name*"
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="border rounded p-2 w-full"
            />
            <input
              type="text"
              placeholder="Internship Field*"
              onChange={(e) => {
                setField(e.target.value);
              }}
              className="border rounded p-2 w-full"
            />
            <input
              type="text"
              placeholder="Date"
              onChange={(e) => {
                setDate(e.target.value);
              }}
              className="border rounded p-2 w-full"
            />
            <input
              type="text"
              placeholder="Image Link"
              onChange={(e) => {
                setImageLink(e.target.value);
              }}
              className="border rounded p-2 w-full"
            />
            <button
              className="px-5 py-2 bg-add-green hover:bg-add-green2 text-white rounded-md"
              onClick={createCertificate}
            >
              Save
            </button>
          </div>
          <div className="w-full mt-10 p-5 flex flex-col gap-5">
            {certificates.map((item, i) => (
              <div key={i} className="border p-2">
                <h1>
                  Name: <span className="font-bold">{item?.Name}</span>
                </h1>
                <p>
                  Internship Field:{" "}
                  <span className="font-bold">{item?.Field}</span>
                </p>
                <p>
                  Certificate Number:{" "}
                  <span className="font-bold">{item?.id}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certificate;
